import React, { useMemo } from 'react'
import MetaWrapper from '@components/Meta/MetaWrapper'
import Page from './Page'
import { useFlatPageQuery } from '@graphql/queries/__generated__/flatpage.generated'
import { WHOLESALE_ROUTES } from '../../../urls'
import { useTranslation } from 'react-i18next'
import { useBlogArticleListAllQuery } from '@graphql/queries/__generated__/blog.generated'
import { Ordering } from '../../../../generated/gqlTypes'
import { BlogArticleFragment } from '@graphql/fragments/__generated__/BlogArticle.generated'
import { useParams } from 'react-router-dom'
import _ from 'lodash'

const View: React.FC = () => {
  const { t } = useTranslation()
  const { slug: blogSlug } = useParams<{ slug: string }>()
  const articlesQueryResult = useBlogArticleListAllQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      first: 20,
      blogSlug,
      orderBy: [{ dateAdded: Ordering.Desc }],
    },
  })

  const fetchMore = async () => {
    if (articlesQueryResult.data.blogArticleList.pageInfo.hasNextPage && !articlesQueryResult.loading) {
      await articlesQueryResult.fetchMore({
        variables: { after: articlesQueryResult.data.blogArticleList.pageInfo.endCursor },
      })
    }
  }

  return (
    <MetaWrapper titleDetails={t('metaTitle.wholesaleBlog', 'Wholesale Blog')}>
      <Page articlesQueryResult={articlesQueryResult} blogSlug={blogSlug} fetchMore={fetchMore} />
    </MetaWrapper>
  )
}

export default View
